
































































import { Component, Vue } from 'vue-property-decorator';
import OtCheckboxGroup, {
  CheckboxGroupItem,
  CheckboxGroupSet,
  CheckboxGroupType,
} from '@/components/global/checkbox-group/ot-checkbox-group.vue';
import OtTextarea from '@/components/global/ot-textarea.vue';
import { OtCalendarStatus } from '@/areas/settings/models/calendar-models';
import { OtSegmentResolution, OtSegmentStatus } from '@/types/status-enums';

@Component({
  components: {
    OtCheckboxGroup,
    OtTextarea,
  },
})
export default class OtCheckboxGroupWrapper extends Vue {
  // * PROPS

  // * REFS

  // * DATA
  private items: CheckboxGroupItem<OtCalendarStatus>[] = [
    new CheckboxGroupItem('Active', OtCalendarStatus.Active),
    new CheckboxGroupItem('Inactive', OtCalendarStatus.Inactive),
  ];
  private value: CheckboxGroupItem<OtCalendarStatus>[] = [];

  private claimStatusFilters: CheckboxGroupType<OtSegmentStatus, OtSegmentResolution>[] = [
    new CheckboxGroupSet<OtSegmentStatus, OtSegmentResolution>('Open', []),
    new CheckboxGroupSet('Closed', [
      new CheckboxGroupSet<OtSegmentStatus, OtSegmentResolution>('Complete', [
        new CheckboxGroupItem('Accepted', OtSegmentResolution.Accepted),
        new CheckboxGroupItem('Rejected', OtSegmentResolution.Rejected),
      ]),
      new CheckboxGroupItem('Withdrawn', OtSegmentStatus.Withdrawn),
      new CheckboxGroupItem('Cancelled', OtSegmentStatus.Cancelled),
      new CheckboxGroupItem('Legal Dispute', OtSegmentStatus.LegalDispute),
      new CheckboxGroupItem('Disputed', OtSegmentStatus.Disputed),
    ]),
  ];
  private selectedClaimStatusFilters: CheckboxGroupItem<OtSegmentStatus>[] = [];

  // * WATCHERS

  // * METHODS

  // * LIFECYCLE
}
